import { filterId } from 'app/area/search-filters/constants';
import { serializeCodes, serializePredefined } from 'app/area/search-filters/serialize/serialize';
import { SerializePayload } from 'app/area/search-filters/types';
import { FilterSearchModel } from 'app/area/search-filters/types-store';

export const serializeQuery = (query: string) => {
  return query && query.trim().length
    ? {
      [filterId.query]: {
        text: query.trim()
      }
    }
    : {};
};

export const serialize = (dataToSerialize: SerializePayload): FilterSearchModel => {
  const { query, formValues, menuValues, filters, filterValidation } = dataToSerialize;
  return {
    ...serializeQuery(query),
    ...serializePredefined(formValues),
    ...serializeCodes(formValues, menuValues, filters, filterValidation)
  };
};
